module.exports = __webpack_public_path__ + "img/speech_3.3a94a744.jpeg";